export default "__VITE_ASSET__648e9a40__"